/*
 * @Auth: linjituan
 * @Date: 2022-03-21 19:43:27
 * @LastEditors: linjituan
 * @LastEditTime: 2022-03-21 19:52:37
 */
import request from '@/utils/request'
const baseURL = '/rc-api'

// 查询角色列表
export function listRole (query) {
  return request({
    url: '/internal/recyclable/role/list',
    method: 'get',
    baseURL,
    params: query
  })
}

// 查询角色详细
export function getRole (roleId) {
  return request({
    url: '/internal/recyclable/role/' + roleId,
    baseURL,
    method: 'get'
  })
}

// 新增角色
export function addRole (data) {
  return request({
    url: '/internal/recyclable/role',
    baseURL,
    method: 'post',
    data: data
  })
}

// 修改角色
export function updateRole (data) {
  return request({
    url: '/internal/recyclable/role',
    baseURL,
    method: 'put',
    data: data
  })
}

// 角色数据权限
export function dataScope (data) {
  return request({
    url: '/internal/recyclable/role/dataScope',
    baseURL,
    method: 'put',
    data: data
  })
}

// 角色状态修改
export function changeRoleStatus (roleId, status) {
  const data = {
    roleId,
    status
  }
  return request({
    url: '/internal/recyclable/role/changeStatus',
    baseURL,
    method: 'put',
    data: data
  })
}

// 删除角色
export function delRole (roleId) {
  return request({
    url: '/internal/recyclable/role/' + roleId,
    baseURL,
    method: 'delete'
  })
}

// 导出角色
export function exportRole (query) {
  return request({
    url: '/internal/recyclable/role/export',
    method: 'get',
    baseURL,
    params: query
  })
}
